// One root for every products query (§8), so invalidating ['products'] reaches the list
// AND the detail. The detail key used to be ['product', id], outside that root, and the
// list mutations invalidated an ['all-products'] key that no query read.
export const productsQueryKeys = {
    all: ['products'] as const,
    list: (filters: Record<string, string>) => ['products', 'list', filters] as const,
    detail: (id?: string) => ['products', 'detail', id] as const,
};
